export const PAYMENT_STATUS_STRINGS = {
  payment_success: "common:paymentComplete",
  payment_fail: "common:paymentFailed",
  cancel_success: "common:paymentCancel",
  refund_require: "common:refundSubmission",
  refund_success: "common:paymentRefund",
};
